<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
  <Header/>
  <div class="titulos">
    <div class="seccionTitle">
      <b-button variant="outline-ligth"  @click="regresar()">
        <b-icon icon="arrow-left-circle" animation="cylon" class="mLeft"></b-icon>
      </b-button>
      <b-icon icon="file-earmark-text-fill"  class="mLeft"></b-icon>
      <div class="headerTxt mLeft">Configuración historia clínica</div>
    </div>
  </div>
  <b-container fluid>
    <b-row class="text-left m-2">
      <b-col cols="10">
        <h5><b> {{nombreClasificacion}} </b> <label> (Dentición: {{ nombreDenticion }})</label></h5>
      </b-col>
      <b-col cols="2">
        <b-button variant="outline-info" pill
                  v-b-tooltip.hover.right.v-primary title="Agregar preguntas"
        @click="agregarEditar(datosAEmodal, 1)">
          <b-icon  icon="plus-circle-fill"></b-icon>
        </b-button>
      </b-col>
    </b-row>



    <b-row>
      <b-col v-if="cargandoPreguntas">
        <b-spinner  variant="primary" ></b-spinner>
      </b-col>
      <b-col  :cols="noColumnas">
        <b-table
            id="cl"
            thead-tr-class="columnas"
            :items="listaPreguntas"
            :fields="encabezados"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            responsive
        >
          <template v-slot:cell(esEmergencia)="row">
            <b-icon variant="success" v-if="row.item.esEmergencia" icon="check-circle-fill"></b-icon>
            <b-icon variant="danger" v-else icon="x-circle-fill"></b-icon>
          </template>
          <template v-slot:cell(requerido)="row">
            <b-icon variant="success" v-if="row.item.requerido" icon="check"></b-icon>
            <b-icon variant="danger" v-else icon="x"></b-icon>
          </template>
          <template v-slot:cell(visualizarEnHdx)="row">
            <b-icon variant="success" v-if="row.item.visualizarEnHdx" icon="check-circle-fill"></b-icon>
            <b-icon variant="danger" v-else icon="x-circle-fill"></b-icon>
          </template>
          <template v-slot:cell(visualizarEnPerfPx)="row">
            <b-icon variant="success" v-if="row.item.visualizarEnPerfPx" icon="check-circle-fill"></b-icon>
            <b-icon variant="danger" v-else icon="x-circle-fill"></b-icon>
          </template>
          <template v-slot:cell(Acciones)="row">
            <b-button-group>
              <b-button pill v-if="row.item.registroActivo && row.item.tipoCampoHtml === 'select'" class=" m-1" size="sm"
                        variant="outline-success"
                        v-b-popover.hover.auto title="Opciones"
                        @click="verOpciones(row.item.descripcionEnfermedad, row.item.opcionesExtraEnfSistemica, row.item.idEnfermedadSistemica)"
              ><b-icon  icon="layout-text-sidebar-reverse"></b-icon>
              </b-button>
              <b-button pill v-if="row.item.registroActivo" class=" m-1"
                        v-b-popover.hover.auto title="Editar"
                        size="sm"
                        variant="outline-warning"
                        @click="agregarEditar(row.item, 2)"
              ><b-icon  icon="pencil-square"></b-icon>
              </b-button>
              <b-button v-if="row.item.registroActivo" pill class=" m-1"
                        v-b-popover.hover.auto title="Inactivar"
                        @click="cambiarEstatusPregunta(row.item.idEnfermedadSistemica, false, 'inactivar')"
                        size="sm"
                        variant="outline-danger"
              ><b-icon  icon="trash"></b-icon>
              </b-button>
              <b-button v-else pill class="m-1"
                        @click="cambiarEstatusPregunta(row.item.idEnfermedadSistemica, true, 'activar')"
                        v-b-popover.hover.auto title="Activar" size="sm" variant="outline-info"
              ><b-icon  icon="arrow-counterclockwise"/>
              </b-button>
            </b-button-group>
          </template>
        </b-table>
        <b-pagination
            v-if="listaPreguntas.length > 10"
            align="center"
            v-model="paginaActual"
            :total-rows="listaPreguntas.length"
            :per-page="registrosPorPagina"
            aria-controls="my-table1"
        ></b-pagination>
      </b-col>
      <b-col v-if="noColumnas !==12">
          <b-card style="border-radius: 10px;  box-shadow: 0px 6px 17px -4px rgba(0, 0, 0, 0.12);  text-align: left;">
            <b-row>
              <b-col cols="6">
                <label>{{titulo}}</label>
              </b-col>
              <b-col cols="3">
                <b-form-checkbox
                    class="letraEstiloNegrita"
                    name="check-button"
                    checked="true"
                    disabled
                > <label
                >Registro activo </label>
                </b-form-checkbox>
              </b-col>
              <b-col cols="3">
                <b-form-checkbox
                    class="letraEstiloNegrita"
                    name="check-button"
                    checked="false"
                    disabled
                > <label
                >Registro inactivo </label>
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6"></b-col>
              <b-col cols="2">
                <b-button  v-b-popover.hover.auto title="Agregar opción" size="sm"
                           @click="agregarOpciones()"
                    pill variant="outline-success">
                  <b-icon  icon="plus-circle"/>
                </b-button>
              </b-col>

              <b-col cols="2">
                <b-button v-b-popover.hover.auto title="Guardar cambios" size="sm"
                    pill variant="outline-primary"
                          @click="guardarOpciones()"
                >
                  <b-icon  icon="check-circle"/>
                </b-button>
              </b-col>

            </b-row>


            <b-table-simple class="mt-4">
              <b-thead class="columnasTablaSinColor">
                <b-tr>
                  <b-th>Id</b-th>
                  <b-th>Descrición</b-th>
                  <b-th>Estatus</b-th>
                </b-tr>
              </b-thead>
              <b-tbody >
                <b-tr v-for="(op, index) in lstOpciones" :key="index">
                  <b-td> {{ op.idOpcionEnfermedadSistemica }} </b-td>
                  <b-td>
                    <div v-if="op.idOpcionEnfermedadSistemica === null">
                      <b-button size="sm" v-b-tooltip.hover title="Eliminar Fila"
                                style="color: red !important;" variant="link"
                                @click="eliminarOpcion(op)"
                      >
                        <font-awesome-icon icon="times-circle"/>
                      </b-button>
                      <b-form-input
                          v-model="op.descripcion"
                          type="text"
                          :id="index+op.descripcion"
                          placeholder="Descripción"
                      ></b-form-input>
                    </div>

                      <div style="display: flex; justify-content: flex-start;" v-else>
                        <b-button size="sm" v-b-tooltip.hover title="Editar descripción"
                                  style="color: gray !important;" variant="link"
                                  @click="op.editarOpcion = !op.editarOpcion;"
                        >
                          <b-icon icon="gear"></b-icon>
                        </b-button>
                        <label v-if="!op.editarOpcion">  {{ op.descripcion }}</label>

                      <b-form-input v-if="op.editarOpcion"
                          v-model="op.descripcion"
                          type="text"
                          :id="index+op.descripcion"
                          placeholder="Descripción"
                      ></b-form-input>
                      </div>

                  </b-td>
                  <b-td inline>
                    <b-form-checkbox
                        class="letraEstiloNegrita"
                        name="check-button"
                        v-model="op.registroActivo"
                        :disabled="op.idOpcionEnfermedadSistemica === null"
                    >
                    </b-form-checkbox>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>

          </b-card>
      </b-col>
    </b-row>



    <b-modal id="modal-1" :title="datosAEmodal.descripcionEnfermedad" v-model="showModal">
      <label> Pregunta o enfermedad: <validacion/></label>
      <b-form-input
          v-model="datosAEmodal.descripcionEnfermedad"
          type="text"
          id="desc"
          minlength="3"
          placeholder="Pregunta/Enfermedad"
          :state="datosAEmodal.descripcionEnfermedad != null && datosAEmodal.descripcionEnfermedad !== '' "
          required
      ></b-form-input>
      <b-row class="mt-4">
        <b-col cols="4"><label> Tipo de campo: <validacion/> </label>
          <b-form-select
              :options="camposHtml"
              v-model="datosAEmodal.idTipoCampoHtml"
              text-field="tipoCampoHtml"
              value-field="idTipoCampoHtml"
          >
          </b-form-select>
        </b-col>
        <b-col cols="4">
          <br>
          <b-form-checkbox
              name="datosAEmodal.requerido"
              v-model="datosAEmodal.requerido"
          > Requerido
          </b-form-checkbox>
        </b-col>
        <b-col cols="4">
          <label> Orden: <validacion/> </label>
          <b-form-input
              v-model="datosAEmodal.orden"
              type="number"
              id="desc"
              placeholder="Orden"
              min="1" max="999"
              :state="datosAEmodal.orden != null && datosAEmodal.orden !== '' "
              required
              @keypress="onlyNumber"
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <b-form-checkbox
              name="datosAEmodal.requerido"
              v-model="datosAEmodal.visualizarEnHdx"
          > Visualizar en hdx
          </b-form-checkbox>
        </b-col>
        <b-col>
          <b-form-checkbox
              name="datosAEmodal.requerido"
              v-model="datosAEmodal.visualizarEnPerfPx"
          > Visualizar en el perfil del paciente
          </b-form-checkbox>
        </b-col>
        <b-col >
          <b-form-checkbox
              name="datosAEmodal.esEmergencia"
              v-model="datosAEmodal.esEmergencia"
          >Aplica en Hc Emergencia
          </b-form-checkbox>
        </b-col>
      </b-row>
      <label class=" mt-4"> Sino aplica un orden o el orden es repetido, el formulario en la historia clínica se ordenará por fecha modificación. </label>
      <template #modal-footer>
        <div >


          <b-button v-if="!loaderModal"
              variant="primary"
              size="sm"
              class=" ml-1"
              @click="guardarCambioPreguntas()"
          >
            Guardar
          </b-button>
          <b-button variant="primary" v-show="loaderModal" disabled>
            <b-spinner small></b-spinner>
            Cargando...
          </b-button>

          <b-button
              variant="secondary"
              size="sm"
              class=" ml-1"
              @click="cerrarModal()"
          >
            Cerrar
          </b-button>


        </div>
      </template>
  </b-modal>


  </b-container>
</div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "PreguntasHc",
  components: {Header},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    cargandoPreguntas: true,
    noColumnas: 12,
    nombreDenticion: "",
    listaPreguntas:[],
    idClasificacion: null,
    nombreClasificacion: "",
    showOpciones:false,
    lstOpciones: [],
    titulo: "",
    encabezados: [
      {key: "idEnfermedadSistemica", label: "Id enfermedad", sortable: true},
      {key: "descripcionEnfermedad", label: "Enfermedad", sortable: true},
      {key: "requerido", label: "Requerido", sortable: true},
      {key: "tipoCampoHtml", label: "Tipo campo", sortable: true},
      {key: "orden", label: "Orden", sortable: true},
      {key: "visualizarEnHdx", label: "Visualizar en Hdx", sortable: true},
      {key: "visualizarEnPerfPx", label: "Visualizar en Perfil", sortable: true},
      {key: "esEmergencia", label: "Aplica en Hc Emergencia", sortable: true},
      "Acciones",
    ],
    camposHtml: [ ],
    registrosPorPagina: 10,
    paginaActual:1,
    showModal: false,
    datosAEmodal:{
      idEnfermedadSistemica: null,
      descripcionEnfermedad: null,
      tipoCampoHtml: null,
      requerido: null,
      orden: null,
      denticion: null,
      idTipoCampoHtml: 1,
      idClasificacionSistemica: null,
      idDenticion: null,
      visualizarEnHdx: false,
      visualizarEnPerfPx: false ,

    },
    idTipoDiente: null,
    loaderModal: false,
    idEnfermedad: null,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idClasificacion = this.$route.params.idClasificacion;
    this.nombreClasificacion = this.$route.params.clasif;
    this.obtenerPreguntasConfiguradas();
    this.obtenerTipoCampos();

  },
  methods: {
    guardarOpciones(){


      this.$http.post(this.$api + 'hc/guardarEditarOpciones', this.lstOpciones).then(respuesta => {
        if (respuesta.data.data){
          this.$swal.fire({
            icon: 'success',
            text: "Se registró correctamente"
          });
        }
      }).finally(() => {
        this.noColumnas = 12;
        this.obtenerPreguntasConfiguradas();

      })
    },
    agregarOpciones(){
      this.lstOpciones.unshift({
        idOpcionEnfermedadSistemica: null,
        descripcion: null,
        registroActivo: true,
        idDenticion: this.idTipoDiente,
        idEnfermedadSistemica: this.idEnfermedad

      })
    },
    eliminarOpcion(item) {
      this.lstOpciones.splice(this.lstOpciones.indexOf(item), 1);
    },
    obtenerTipoCampos(){
      this.$http.get(this.$api + 'hc/obtenerListaTipoCampos').then(respuesta => {
        if (respuesta.data.data){
          this.camposHtml = respuesta.data.data
        }

      })
    },
    guardarCambioPreguntas(){

      if (this.datosAEmodal.descripcionEnfermedad === null || this.datosAEmodal.descripcionEnfermedad === ''
          || this.datosAEmodal.orden === null || this.datosAEmodal.orden === ''){
        this.$swal.fire({
          icon: 'error',
          text: "Por favor llene los campos obligatorios",
          showConfirmButton: false,
          timer: 1500,
        });
        return;
      }


      this.loaderModal = true;
      this.$http.post(this.$api + 'hc/guardarEditarPregunta', this.datosAEmodal).then(respuesta => {
        if (respuesta.data.data){
          this.$swal.fire({
            icon: 'success',
            text: "Se registró correctamente",
            showConfirmButton: false,
            timer: 1500,
          });
        }
      }).finally(() => {
        this.obtenerPreguntasConfiguradas();
        this.loaderModal = false;
        this.showModal = false;

      })

    },
    cerrarModal(){

      this.showModal = false;
    },
    agregarEditar(datos, guardar){
      this.noColumnas = 12;
      this.showModal = true;

      if (guardar===1){
        this.datosAEmodal ={
              idEnfermedadSistemica: null,
              descripcionEnfermedad: null,
              tipoCampoHtml: null,
              requerido: false,
              orden: 0,
              denticion: null,
              idTipoCampoHtml: 1,
              idClasificacionSistemica: this.idClasificacion,
              idDenticion: this.idTipoDiente,
              esEmergencia: false,
        }

      }else{
        this.datosAEmodal = datos;
      }



    },
    verOpciones(titulo, ops, idEnfermedad){

        this.noColumnas = 6;
      this.lstOpciones = ops;
      this.titulo = titulo;
      this.idEnfermedad = idEnfermedad;
    },
    cambiarEstatusPregunta(idEnfermedad, estatus, texto){
      this.$swal.fire({
        title: '¿Está seguro de ' + texto + ' el registro?',
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ok",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          this.cargandoPreguntas = true;
          const params = {
            idPregunta: idEnfermedad,
            estatus: estatus,
          }
          this.$http.put(this.$api + "hc/cambiarEstatusPregunta", params )
              .then(() => {
                this.$swal.fire({
                  icon: 'success',
                  text: "Se registró correctamente"
                });

              }).finally(()=> {
                this.obtenerPreguntasConfiguradas();
                this.cargandoPreguntas = false;
              })
        }
      })

    },
    obtenerPreguntasConfiguradas(){
      this.cargandoPreguntas = true;
      const params = {
        idClasificacion: this.idClasificacion
      }
      let urlMedio = this.$api + "hc/obtenerEnfermedadesConf";
      this.$http.post(urlMedio, params).then((response) => {
        if (response.data.data) {
          this.listaPreguntas = response.data.data;
        }
      })
          .catch((err) => {
            this.errorMensaje(err);
          })
          .finally(() => {
            this.cargandoPreguntas = false;
            this.idTipoDiente = this.listaPreguntas.length > 0 ? this.listaPreguntas[0].idDenticion :  this.$route.params.idDenticion;
            if(this.idTipoDiente === 1){
              this.nombreDenticion = "Infantil";
            }else {
              this.nombreDenticion = "Adulto";
            }


          });
    },
    regresar() {
      this.$router.push({name:"configuracionFormularioHc"})
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
  }
}
</script>

<style scoped>

</style>